import { isNumber } from "lodash";

import type { Order } from "../../../../../../../services";
import type { DateFns } from "../../../../../../../utils/DateFns";

const cellProcessing = (item?: Order.Model, dateFns?: DateFns): string => {
	if (!item?.id || !dateFns) return "";

	const idle = isNumber(item?.additionalFields?.idleTimeMilliseconds)
		? item.additionalFields.idleTimeMilliseconds
		: 0;

	const withClients = isNumber(item?.downtimes?.withClients)
		? item.downtimes.withClients
		: 0;

	const base = Math.max(idle, withClients);
	const total = Math.max(base, 0);

	if (!total) return "";

	return dateFns.formatTime(total, {
		formatTime: "HH:mm:ss",
		timezone: "UTC",
		isTimezone: true,
	});
};

export default cellProcessing;
